import React from 'react'
import { Layout, Spin } from 'antd'
import { withRouter, Route, Redirect } from 'react-router-dom'
import './main-page.less'
import {getCookie} from '../public/utils'
class MainPageRoute extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      status: 'logged'
    }
  }
  componentDidMount () {
    // 判断登录信息
    const loginInfo = window.localStorage.getItem('token') || getCookie('localToken')
    // 不需要判断登录的页面
    let noNeedlogin = false
    let noNeedLoginList = ['udeskSide', 'mobilepage']
    let initscale = ['mobilepage'] // 无需缩放的页面
    noNeedLoginList.map(i => {
      if (window.location.pathname.indexOf(i) > -1) {
        noNeedlogin = true
      }
    })
    initscale.map(item => {
      if ((window.location.pathname.indexOf(item) > -1) || (window.location.search.indexOf(item)) > -1) {
        let viewport = document.getElementById('viewport')
        viewport.content = 'width=device-width,initial-scale=1,maximum-scale=1.0'
      } else {
        let viewport = document.getElementById('viewport')
        viewport.content = 'width=device-width,initial-scale=0.01,maximum-scale=1.0'
      }
    })
    // if (noNeedlogin) {
    //   this.setState({ status: 'logged' })
    // } else {
    //   if (!loginInfo) {
    //     this.setState({ status: 'logout' })
    //   } else {
    //     this.setState({ status: 'logged' })
    //   }
    // }
    // 可以继续配合接口判断权限信息
  }
  componentWillUnmount () {
    this.setState = (state, callback) => {

    }
  }

  render () {
    const { status } = this.state
    const { component, ...rest } = this.props
    if (status === 'pending') return <div className="full-center"><Spin /></div>
    if (status === 'logout') return <Redirect to="/login" />
    if (status === 'logged') return <Route {...rest} render={props => React.createElement(component, props)} />
  }
}

export default withRouter(MainPageRoute)



// WEBPACK FOOTER //
// ./src/layout/main-page.js